export enum NavigationSegments {
  ROOT = '',
  LOGIN = 'login',
  LOCATION = 'location',
  ITEM = 'item',
  ERROR = 'error',
}
